var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-list"},_vm._l((_vm.users),function(user){return _c('UserItem',{key:user.href,attrs:{"title":user.title,"href":user.href,"avatar":user.avatar,"avatar-size":"medium-small"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }